import { render, staticRenderFns } from "./Landing3HowItWorks.vue?vue&type=template&id=279dc992&scoped=true&"
import script from "./Landing3HowItWorks.vue?vue&type=script&lang=js&"
export * from "./Landing3HowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./Landing3HowItWorks.vue?vue&type=style&index=0&id=279dc992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279dc992",
  null
  
)

export default component.exports